// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.padding-container {
  background-color: rgb(235, 235, 235);
  width: 100%;
  padding: 8%;
}

ion-content::part(background) {
  background: white;
  background-color: rgb(235, 235, 235);
}

.top-content {
  background: var(--ion-color-primary);
  width: 100%;
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 10%;
  border-radius: 15px;
}

.content-h2 {
  margin: 3% 5%;
  font-weight: 400;
  font-size: 22px;
  color: white;
  justify-content: flex-start;
  position: relative;
  left: 0;
}

.content-h4 {
  color: white;
  font-size: 22px;
  text-align: center;
  align-self: stretch;
  padding-bottom: 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.content-h3 {
  color: white;
  margin: 0 5% 2% 5%;
  font-size: 12px;
  margin-top: 5px;
  align-self: center;
}

.content-span {
  font-size: 23px;
}

.top-totals {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}

.totals-h2 {
  font-size: 16px;
}

.totals-h3 {
  font-size: 14px;
}

ion-segment {
  --background: var(--ion-color-primary-tint-lighter);
}

ion-segment-button {
  --background-checked: var(--ion-color-primary);
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary-contrast);
  --indicator-color: transparent;
  --indicator-height: 0;
}

.footer {
  margin-top: 15px;
  background-color: rgb(235, 235, 235);
  width: 100%;
  padding: 0 36px 36px 36px;
  height: 100%;
}

.footer-container {
  background-color: white;
  margin: 15px 0;
  padding: 15px 12px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.footer-icon-container {
  align-items: center;
  justify-content: center;
  min-width: 40px;
}

.footer-icon {
  color: white;
  background-color: #00ced1;
  padding: 6px;
  border-radius: 50%;
  font-size: 22px;
}

.footer-h2 {
  font-weight: 700;
  font-size: 17px;
  color: var(--ion-color-primary);
}

.footer-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--ion-color-primary);
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--ion-color-light-shade, #e0e0e0);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.footer-h3 {
  font-size: 15px;
  color: var(--ion-color-primary);
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-span {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 0;
  font-size: 15px;
  color: var(--ion-color-primary);
}
.footer-span ion-icon {
  flex: 0 0 auto;
  font-size: 18px;
  color: var(--ion-color-primary-tint);
}

@media screen and (min-width: 550px) {
  .content-h4 {
    font-size: 28px;
  }
  .content-span {
    font-size: 30px;
  }
  .top-content {
    padding: 5%;
    height: auto;
  }
  .totals-h2 {
    font-size: 22px;
  }
  .totals-h3 {
    font-size: 22px;
  }
  .padding-container {
    padding: 8% 8% 4% 8%;
  }
  ion-segment-button {
    height: 40px;
    font-size: 22px;
  }
  .footer-h3 {
    font-size: 20px;
  }
  .footer-span {
    font-size: 20px;
  }
}
@media (min-width: 992px) {
  .main {
    display: grid;
    grid-template-columns: 360px 1fr;
    gap: 32px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 32px 24px;
    align-items: start;
  }
  .padding-container {
    padding: 0;
    background: transparent;
    position: sticky;
    top: 24px;
  }
  .top-content {
    width: 100%;
    height: auto;
    padding: 28px 28px 24px;
    border-radius: 16px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
  }
  .content-h4 {
    font-size: 16px;
    text-align: center;
    padding-bottom: 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
    margin-bottom: 4px;
    align-self: stretch;
    color: #fff;
  }
  .content-span {
    display: block;
    font-size: 28px;
    font-weight: 600;
    margin-top: 6px;
  }
  .top-totals {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-top: 20px;
  }
  .total-incomes,
  .total-deduccion {
    text-align: left;
  }
  .total-incomes .totals-h2,
  .total-deduccion .totals-h2 {
    color: #fff;
    font-size: 13px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.85;
  }
  .total-incomes .totals-h3,
  .total-deduccion .totals-h3 {
    color: #fff;
    font-size: 22px;
    font-weight: 600;
    margin-top: 2px;
  }
  .footer {
    margin-top: 0;
    padding: 0;
    background: transparent;
    height: auto;
  }
  ion-segment {
    width: 100%;
    margin: 0;
  }
  ion-segment-button {
    height: 64px;
    min-height: 64px;
    font-size: 20px;
    font-weight: 500;
  }
  .footer > div {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .footer-container {
    margin: 0;
    padding: 16px 20px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/payment-flyer-details/payment-flyer-details.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAIA;EACE,oCAAA;EACA,WAAA;EACA,WAAA;AADF;;AAIA;EACE,iBAAA;EACA,oCAAA;AADF;;AAIA;EACE,oCAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;AADF;;AAKA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kDAAA;AAFF;;AAIA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;AADF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,mDAAA;AAAF;;AAKA;EACE,8CAAA;EACA,iCAAA;EACA,kDAAA;EACA,8BAAA;EACA,qBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,oCAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AAFF;;AAKA;EACE,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAFF;;AAIA;EACE,mBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAGA;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,+BAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,8DAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,oCAAA;AACJ;;AAIA;EACE;IACE,eAAA;EADF;EAIA;IACE,eAAA;EAFF;EAIA;IACE,WAAA;IACA,YAAA;EAFF;EAIA;IACE,eAAA;EAFF;EAIA;IACE,eAAA;EAFF;EAIA;IACE,oBAAA;EAFF;EAIA;IACE,YAAA;IACA,eAAA;EAFF;EAIA;IACA,eAAA;EAFA;EAIA;IACE,eAAA;EAFF;AACF;AAWA;EACE;IACE,aAAA;IACA,gCAAA;IACA,SAAA;IACA,iBAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;EATF;EAaA;IACE,UAAA;IACA,uBAAA;IACA,gBAAA;IACA,SAAA;EAXF;EAcA;IACE,WAAA;IACA,YAAA;IACA,uBAAA;IACA,mBAAA;IACA,2CAAA;EAZF;EAeA;IACE,eAAA;IACA,kBAAA;IACA,oBAAA;IACA,kDAAA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;EAbF;EAgBA;IACE,cAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;EAdF;EAkBA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,gBAAA;EAhBF;EAmBA;;IAEE,gBAAA;EAjBF;EAmBE;;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,yBAAA;IACA,qBAAA;IACA,aAAA;EAhBJ;EAmBE;;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;EAhBJ;EAqBA;IACE,aAAA;IACA,UAAA;IACA,uBAAA;IACA,YAAA;EAnBF;EAsBA;IACE,WAAA;IACA,SAAA;EApBF;EAuBA;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EArBF;EAyBA;IACE,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAvBF;EA0BA;IACE,SAAA;IACA,kBAAA;IACA,mBAAA;IACA,yCAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;EAxBF;AACF","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n\n//reusables\n.padding-container{\n  background-color: rgb(235, 235, 235);\n  width: 100%;\n  padding: 8%;\n}\n\nion-content::part(background){\n  background: white;\n  background-color: rgb(235, 235, 235);\n}\n\n.top-content{\n  background: var(--ion-color-primary);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  padding: 10%;\n  border-radius: 15px;\n}\n\n.content-h2{\n  margin: 3% 5%;\n  font-weight: 400;\n  font-size: 22px;\n  color: white;\n  justify-content: flex-start;\n  position: relative;\n  left: 0;\n}\n\n\n.content-h4{\n  color: white;\n  font-size: 22px;\n  text-align: center;\n  align-self: stretch;\n  padding-bottom: 12px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n}\n.content-h3{\n  color: white;\n  margin: 0 5% 2% 5%;\n  font-size: 12px;\n  margin-top: 5px;\n  align-self: center;\n\n}\n.content-span{\n  font-size: 23px;\n}\n\n.top-totals{\n  display: flex;\n  justify-content: space-around;\n  margin-top: 10px;\n}\n.totals-h2{\n  font-size: 16px;\n}\n\n.totals-h3{\n  font-size: 14px;\n}\n\nion-segment {\n  --background: var(--ion-color-primary-tint-lighter);\n}\n\n// Drop the default underline indicator and use a solid background fill\n// for the active tab instead.\nion-segment-button {\n  --background-checked: var(--ion-color-primary);\n  --color: var(--ion-color-primary);\n  --color-checked: var(--ion-color-primary-contrast);\n  --indicator-color: transparent;\n  --indicator-height: 0;\n}\n\n.footer{\n  margin-top: 15px;\n  background-color: rgb(235, 235, 235);\n  width: 100%;\n  padding:  0 36px 36px 36px;\n  height: 100%;\n}\n\n.footer-container{\n  background-color: white;\n  margin: 15px 0;\n  padding: 15px 12px;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.footer-icon-container{\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n}\n.footer-icon{\n  color: white;\n  background-color: #00ced1;\n  padding: 6px;\n  border-radius: 50%;\n  font-size: 22px;\n}\n.footer-h2{\n  font-weight: 700;\n  font-size: 17px;\n  color: var(--ion-color-primary);\n}\n\n.footer-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--ion-color-primary);\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid var(--ion-color-light-shade, #e0e0e0);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.footer-h3{\n  font-size: 15px;\n  color: var(--ion-color-primary);\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.footer-span{\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 0;\n  font-size: 15px;\n  color: var(--ion-color-primary);\n\n  ion-icon {\n    flex: 0 0 auto;\n    font-size: 18px;\n    color: var(--ion-color-primary-tint);\n  }\n}\n\n\n@media screen and (min-width: 550px) {\n  .content-h4{\n    font-size: 28px;\n  }\n\n  .content-span{\n    font-size: 30px;\n  }\n  .top-content{\n    padding: 5%;\n    height: auto;\n  }\n  .totals-h2{\n    font-size: 22px;\n  }\n  .totals-h3{\n    font-size: 22px;\n  }\n  .padding-container{\n    padding: 8% 8% 4% 8%;\n  }\n  ion-segment-button{\n    height: 40px;\n    font-size: 22px;\n  }\n  .footer-h3{\n  font-size: 20px;\n  }\n  .footer-span{\n    font-size: 20px;\n  }\n}\n\n// ============================================================\n// Desktop layout (≥992px) — brand-new two-column grid\n//   ┌── Summary (360px sticky) ──┐ ┌── Items pane ──────┐\n//   │ Total + Ingresos/Deduc.    │ │ Segment + cards    │\n//   └────────────────────────────┘ └────────────────────┘\n// ============================================================\n@media (min-width: 992px) {\n  .main {\n    display: grid;\n    grid-template-columns: 360px 1fr;\n    gap: 32px;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 32px 24px;\n    align-items: start;\n  }\n\n  // Left column: summary card\n  .padding-container {\n    padding: 0;\n    background: transparent;\n    position: sticky;\n    top: 24px;\n  }\n\n  .top-content {\n    width: 100%;\n    height: auto;\n    padding: 28px 28px 24px;\n    border-radius: 16px;\n    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);\n  }\n\n  .content-h4 {\n    font-size: 16px;\n    text-align: center;\n    padding-bottom: 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n    margin-bottom: 4px;\n    align-self: stretch;\n    color: #fff;\n  }\n\n  .content-span {\n    display: block;\n    font-size: 28px;\n    font-weight: 600;\n    margin-top: 6px;\n  }\n\n  // Stack Ingresos / Deducciones vertically inside the card\n  .top-totals {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    margin-top: 20px;\n  }\n\n  .total-incomes,\n  .total-deduccion {\n    text-align: left;\n\n    .totals-h2 {\n      color: #fff;\n      font-size: 13px;\n      font-weight: 400;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      opacity: 0.85;\n    }\n\n    .totals-h3 {\n      color: #fff;\n      font-size: 22px;\n      font-weight: 600;\n      margin-top: 2px;\n    }\n  }\n\n  // Right column: tab segment + items\n  .footer {\n    margin-top: 0;\n    padding: 0;\n    background: transparent;\n    height: auto;\n  }\n\n  ion-segment {\n    width: 100%;\n    margin: 0;\n  }\n\n  ion-segment-button {\n    height: 64px;\n    min-height: 64px;\n    font-size: 20px;\n    font-weight: 500;\n  }\n\n  // Items list — single column, full width of the right pane\n  .footer > div {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .footer-container {\n    margin: 0;\n    padding: 16px 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
